var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCsv = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26.62 36.49"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".csv_svg__g{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:.311px}"))), /*#__PURE__*/React.createElement("path", {
  d: "M.882 0A.884.884 0 0 0 0 .882v31.1a.884.884 0 0 0 .882.882h24.856a.884.884 0 0 0 .882-.882V10.668A2.453 2.453 0 0 0 26 9.163L17.458.624A2.45 2.45 0 0 0 15.952 0Z",
  style: {
    fill: "gray"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.241 1.887a.885.885 0 0 0-.882.882v30.217a.885.885 0 0 0 .882.882h23.828a.885.885 0 0 0 .882-.882V12.114a2.457 2.457 0 0 0-.624-1.505l-8.1-8.1a2.457 2.457 0 0 0-1.505-.623Z",
  transform: "translate(-1.624 -1.299)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.047 9.4v4.407a1.682 1.682 0 0 0 1.681 1.682h4.581Z",
  transform: "translate(-38.594 -6.476)",
  style: {
    fill: "#eaecef"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m52.661 10.83-.405-7.252-.624 8.281a.885.885 0 0 0 .882.882h8.022l-6.994-1.029a.885.885 0 0 1-.881-.882Z",
  transform: "translate(-35.554 -2.464)",
  style: {
    fill: "#e6e7e8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.951 54.351a.782.782 0 0 1-.791.767H3.15a.782.782 0 0 1-.791-.767V45.4a.782.782 0 0 1 .791-.768h24.01a.782.782 0 0 1 .791.768Z",
  transform: "translate(-1.624 -30.736)",
  style: {
    fill: "#d3713c"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.951 55.8a.782.782 0 0 1-.791.767H3.15a.782.782 0 0 1-.791-.767v-8.949a.781.781 0 0 1 .791-.767h24.01a.781.781 0 0 1 .791.767Z",
  transform: "translate(-1.624 -31.733)",
  style: {
    fill: "#f29151"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "csv_svg__g",
  d: "M10.807 22.53a4.486 4.486 0 0 1-2.1.5 3.043 3.043 0 0 1-2.346-.891 4.254 4.254 0 0 1 .016-5.063 3.106 3.106 0 0 1 2.379-.9 8.723 8.723 0 0 1 2.047.29v.869a6.815 6.815 0 0 0-2.066-.47 1.994 1.994 0 0 0-1.643.719 3.152 3.152 0 0 0-.581 2.03 2.919 2.919 0 0 0 .621 1.973 2.128 2.128 0 0 0 1.7.719 4.186 4.186 0 0 0 1.977-.571ZM11.747 22.741v-.916a4.523 4.523 0 0 0 1.815.517 1.286 1.286 0 0 0 .874-.289.951.951 0 0 0 .333-.753 1 1 0 0 0-.218-.653 2.88 2.88 0 0 0-.8-.6l-.449-.26a4.226 4.226 0 0 1-1.172-.9 1.505 1.505 0 0 1-.341-.977 1.6 1.6 0 0 1 .545-1.245 2.01 2.01 0 0 1 1.39-.487 5.533 5.533 0 0 1 1.588.251v.845a4.725 4.725 0 0 0-1.535-.407 1.2 1.2 0 0 0-.792.256.8.8 0 0 0-.312.645.835.835 0 0 0 .229.579 3.651 3.651 0 0 0 .836.6l.467.264a4.052 4.052 0 0 1 1.18.908 1.616 1.616 0 0 1 .334 1.027 1.684 1.684 0 0 1-.625 1.367 2.532 2.532 0 0 1-1.662.516 6.454 6.454 0 0 1-1.685-.288Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M54.163 59.2 51.7 52.68h.929l2.014 5.335 1.95-5.335h.807l-2.366 6.52Z",
  transform: "translate(-35.601 -36.276)",
  style: {
    strokeWidth: ".311px",
    stroke: "#fff",
    strokeMiterlimit: 10,
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.653 87.306v-3.892H31.6v3.892h-2.13l4.13 5.133 4.133-5.132Z",
  transform: "translate(-20.293 -57.439)",
  style: {
    strokeWidth: "1.868px",
    stroke: "#fff",
    strokeMiterlimit: 10,
    fill: "#f29151"
  }
}));
export default SvgCsv;